import React from "react";
import Modal from "../../../modal";
import styles from "./styles.module.css";
import { db } from "../../../firebase";
import Billing from "./billing";

export default function Account({ onClose, user }) {
  const [account, setAccount] = React.useState(null);

  React.useEffect(() => {
    let unsub;
    if (user) {
      unsub = db
        .collection("users")
        .doc(user.uid)
        .onSnapshot((doc) => {
          setAccount({ ...doc.data(), id: doc.id });
        });
    }
    return unsub;
  }, [user]);

  if (!account) {
    return null;
  }
  return (
    <Modal onClose={onClose} open={true}>
      <div className={styles.account}>
        <div className={styles.accountTitle}>Account</div>
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Info</div>
          <div>{account.email}</div>
        </div>
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Billing</div>
          <Billing billing={account.billing} />
        </div>
      </div>
    </Modal>
  );
}
